const config = {};

function configFn() {
  config.name = "初中重难点";
  config.HOME = "//mv.xueersi.com";
  config.ABOUT_ME = "//www.xueersi.com/article/detail/1903";
  config.ZHAOPIN = "http://job.100tal.com/xueersi";
  config.HEZUO = "//www.xueersi.com/article/detail/1220";
  config.CONCAT_US = "//www.xueersi.com/article/detail/1538";
  config.AI_PLATFORM = "//ai.xueersi.com/";
  config.FEEDBACK = "//www.xueersi.com/StudentFeedback/apply/";
  config.LOUDONG = "http://src.100tal.com";
  config.protocol = {
    user: {
      name: "用户权限",
      path: "https://app.xueersi.com/xueersi-mall-hm-xbjtoxes/agreement#protect",
    },
    privacy: {
      name: "用户个人信息保护政策",
      path: "https://app.xueersi.com/xueersi-mall-hm-xbjtoxes/privacy",
    },
    child: {
      name: "儿童个人保护政策",
      path: "https://app.xueersi.com/xueersi-mall-hm-xbjtoxes/childpolicy",
    },
  };
  config.BANQUAN = "//www.xueersi.com/article/detail/1495";
  config.FANDAOLIAN = "//www.xueersi.com/article/detail/1944";
  config.JUBAO = "//www.12377.cn/";
  config.GONGSHI = "//www.xueersi.com/article/detail/1996";
  config.BUS_LICENSE = "//www.xueersi.com/businessLicense";
  config.TEACHER_LICENSE = "https://app.xueersi.com/teaching-license-pc";
  config.SHOW_HU_MIAO = true;
  config.CUSTOMER_PHONE_HTML =
    '客服电话：<strong class="telphone">400-800-2211</strong> （免长途话费）';
  config.JUBAO_PHINE = "010-86483589-6 ";
  config.JUBAO_MAIl = "xeswxjubao@tal.com";
  config.ZHU_TI_INFO = {
    startYear: "2009",
    name: "初中重难点",
  };
  config.ADRESS = "地址：北京市昌平区回龙观东大街龙冠和谐大厦";
  config.ICP = {
    zheng: "京ICP证080230号",
    bei: "京ICP备09032638号",
    anbei: "京公网安备 11010802020171号",
  };
  config.CHENGXIN_DANWEI =
    "https://credit.szfw.org/CX20121010001753002020.html";
  config.downloadList = [
    {
      name: "Windows",
      class: "win",
      icon: require("./assets/img/win.png"),
      redIcon: require("./assets/img/win-red.png"),
    },
    {
      class: "mac",
      name: "Mac",
      icon: require("./assets/img/mac.png"),
      redIcon: require("./assets/img/mac-red.png"),
    },

    {
      class: "android",
      name: "Android",
      icon: require("./assets/img/android.png"),
      redIcon: require("./assets/img/android-red.png"),
    },
    {
      class: "iphone",
      name: "iPhone",
      icon: require("./assets/img/ios.png"),
      redIcon: require("./assets/img/ios-red.png"),
    },
  ];
  config.downloadInfo = {
    win: {
      title: "自主学习好帮手",
      name: "Windows客户端",
      src: require("./assets/img/android-code.png"),
      tips: "用手机扫描二维码",
      version: "01.10",
      date: "2022年1月13日",
      support: "--",
    },
    mac: {
      title: "自主学习好帮手",
      name: "Mac客户端",
      src: require("./assets/img/android-code.png"),
      tips: "用手机扫描二维码",
      version: "01.10",
      date: "2022年1月13日",
      support: "--",
    },
    android: {
      title: "自主学习好帮手",
      name: "Android客户端",
      src: require("./assets/img/android-download-guide-code.png"),
      tips: "用手机扫描二维码",
      version: "1.00.03",
      date: "2022年1月28日",
      support: "6.0及以上系统版本,2GB及以上运行内存",
    },
    iphone: {
      title: "自主学习好帮手",
      name: "iPhone客户端",
      src: require("./assets/img/unidownload-qrcode.png"),
      tips: "用手机扫描二维码",
      version: "1.0.03",
      date: "2022年1月20日",
      support: "iOS 10.0及以上系统版本",
    },
  };
  config.homeList = {
    difficulty: {
      title: "为什么选择初中重难点？",
      list: [
        {
          src: require("@/assets/img/tixihua.png"),
          name: "体系化",
          info: "测学练评，独创闭环模式。通过轻松检测-->高效学习-->专项练习-->整体测评的闭环，系统学习薄弱知识点。",
        },
        {
          src: require("@/assets/img/gexinghua.png"),
          name: "个性化",
          info: "专属内容，满足个性需求。通过前测快速诊断薄弱环节，针对性推荐制定个性化的学习方案，学习重难知识点。",
        },
        {
          src: require("@/assets/img/wujiandu.png"),
          name: "无监督",
          info: "自主学习，及时查漏补缺。按照自身掌握情况进行自主学习，通过首页推荐内容和大纲目录，成为学生课后巩固，查漏补缺的好工具。",
        },
        {
          src: require("@/assets/img/tongbuhua.png"),
          name: "同步化",
          info: "校内进度，实现同步学习。分年纪、科目、版本，教材版本和教学进行高度适配，给学生提供每周同步巩固计划。",
        },
      ],
    },
    path: {
      title: "初中重难点的自学路径",
      list: [
        {
          // src: "//static0.xesimg.com/wx-mobile-fe/mv_fe_index/cdn/img/ce.ff715c4e.png",
          src: require("@/assets/img/ce.png"),
          name: "测",
          info: "通过精心选择的题目，帮助学生诊断自身问题，通过大数据&人工智能技术为学生制定个性化的学习方案。",
        },
        {
          src: require("@/assets/img/xue.png"),
          name: "学",
          info: "围绕学生掌握较为薄弱的知识点，给学生个性化提供灵活视频集，通过短视频学习，助力提升效率，巩固知识。",
        },
        {
          src: require("@/assets/img/lian.png"),
          name: "练",
          info: "在每个视频学习结束后，配套若干道对应的专项练习题，即时检测视频掌握情况。",
        },
        {
          src: require("@/assets/img/ping.png"),
          name: "评",
          info: "在每个薄弱知识点的学习任务后，提供一套播单对应的整体测评卷，检测学生是否已经掌握该知识点，并声称相关学习报告，目前暂无测评功能，后期会更新上线。",
        },
      ],
    },
  };
  return config;
}

export default configFn;
